export default {
  name: "Review",
  plural: "Reviews",
};
